/**
 * useModalState - Custom hook for managing multiple modal states
 * Reusable hook for components with multiple modals
 */

import { useState, useCallback } from 'react';

export const useModalState = () => {
  const [modals, setModals] = useState({
    sale: false,
    pie: false,
    error: false,
    share: false,
  });

  const [modalData, setModalData] = useState({
    card: {},
    popUpCard: {},
    errorMessage: '',
    saleStatus: '',
    priceDist: 0,
  });

  // Generic modal toggle
  const toggleModal = useCallback((modalName, isOpen = null) => {
    setModals(prev => ({
      ...prev,
      [modalName]: isOpen !== null ? isOpen : !prev[modalName]
    }));
  }, []);

  // Specific modal handlers
  const openSaleModal = useCallback((card, status) => {
    setModalData(prev => ({
      ...prev,
      card,
      saleStatus: status,
      priceDist: card.originalPrice || 0
    }));
    toggleModal('sale', true);
  }, [toggleModal]);

  const closeSaleModal = useCallback(() => {
    toggleModal('sale', false);
  }, [toggleModal]);

  const openErrorModal = useCallback((errorMessage) => {
    setModalData(prev => ({ ...prev, errorMessage }));
    toggleModal('error', true);
  }, [toggleModal]);

  const closeErrorModal = useCallback(() => {
    toggleModal('error', false);
  }, [toggleModal]);

  const openShareModal = useCallback((card) => {
    setModalData(prev => ({ ...prev, card }));
    toggleModal('share', true);
  }, [toggleModal]);

  const closeShareModal = useCallback(() => {
    toggleModal('share', false);
  }, [toggleModal]);

  const openPieModal = useCallback((card) => {
    setModalData(prev => ({ ...prev, popUpCard: card }));
    toggleModal('pie', true);
  }, [toggleModal]);

  const closePieModal = useCallback(() => {
    toggleModal('pie', false);
  }, [toggleModal]);

  const updateModalData = useCallback((updates) => {
    setModalData(prev => ({ ...prev, ...updates }));
  }, []);

  return {
    modals,
    modalData,
    toggleModal,
    updateModalData,
    // Specific handlers
    openSaleModal,
    closeSaleModal,
    openErrorModal,
    closeErrorModal,
    openShareModal,
    closeShareModal,
    openPieModal,
    closePieModal,
  };
};
